import arraySort from 'array-sort'

import dayjs from '@/lib/utils/dayjs'

export function useSortingMethods() {
  const sortByAlphaDesc = (arr, prop) => {
    if (arr && arr.length) {
      return arraySort(arr, prop)
    } else {
      return []
    }
  }

  const sortByAlphaAsc = (arr, prop) => {
    if (arr && arr.length) {
      return arraySort(arr, prop).reverse()
    } else {
      return []
    }
  }

  const sortByFeatured = (arr) => {
    if (arr && arr.length) {
      return arr.sort(withSortByFeatured())
    } else {
      return []
    }
  }

  const sortByDateDesc = (arr) => {
    if (arr && arr.length) {
      return arr.sort(withSortByDateDesc())
    } else {
      return []
    }
  }

  const withSortByFeatured = () => {
    return function (a, b) {
      if (a.isFeatured && b.isFeatured) {
        if ((a.featuredRank && !b.featuredRank) || a.featuredRank < b.featuredRank) return -1
        if ((b.featuredRank && !a.featuredRank) || a.featuredRank > b.featuredRank) return 1
        return a.title.localeCompare(b.title)
      } else if (a.isFeatured && !b.isFeatured) {
        return -1
      } else if (!a.isFeatured && b.isFeatured) {
        return 1
      } else {
        return a.title.localeCompare(b.title)
      }
    }
  }

  const withSortByFeaturedAndDate = (sortRestByDate) => {
    return function (a, b) {
      if (a.isFeatured && b.isFeatured) {
        if ((a.featuredRank && !b.featuredRank) || a.featuredRank < b.featuredRank) return -1
        if ((b.featuredRank && !a.featuredRank) || a.featuredRank > b.featuredRank) return 1
        if (a.date === b.date) return 0
        if (!a.date) return 1
        if (!b.date) return -1
        return dayjs(b.date).diff(dayjs(a.date))
      } else if (a.isFeatured && !b.isFeatured) {
        return -1
      } else if (!a.isFeatured && b.isFeatured) {
        return 1
      } else {
        if (sortRestByDate) {
          if (a.date === b.date) return 0
          if (!a.date) return 1
          if (!b.date) return -1
          return dayjs(b.date).diff(dayjs(a.date))
        }
        return a.title.localeCompare(b.title)
      }
    }
  }

  const withSortByDateDesc = () => {
    return function (a, b) {
      if (a.date === b.date) return 0
      if (!a.date) return 1
      if (!b.date) return -1
      return dayjs(b.date).diff(dayjs(a.date))
    }
  }

  const withSortByFirstTwoWordsOfProp = (prop) => {
    return function (a, b) {
      if (a[prop].split(' ')[0] === b[prop].split(' ')[0]) {
        return a[prop].split(' ')[1]?.localeCompare(b[prop].split(' ')[1])
      } else {
        return a[prop].localeCompare(b[prop])
      }
    }
  }

  const withSortByOneOfTwoProps = (propA, propB) => {
    return function (a, b) {
      const propToUseForA = a[propA] ? propA : propB
      const propToUseForB = b[propA] ? propA : propB
      return a[propToUseForA].localeCompare(b[propToUseForB])
    }
  }
  return {
    sortByAlphaDesc,
    sortByAlphaAsc,
    sortByFeatured,
    sortByDateDesc,
    withSortByFeatured,
    withSortByFeaturedAndDate,
    withSortByDateDesc,
    withSortByFirstTwoWordsOfProp,
    withSortByOneOfTwoProps,
  }
}
